import { render, staticRenderFns } from "./RouterLinkEscape.vue?vue&type=template&id=254909ca&"
import script from "./RouterLinkEscape.vue?vue&type=script&lang=js&"
export * from "./RouterLinkEscape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports